<template>
  <v-btn
    v-if="!activeAccount"
    class="wallet-connect-btn"
    data-cy="connect-wallet"
    :color="outlined ? undefined : 'primary'"
    :variant="outlined ? 'outlined' : 'flat'"
    :size="size"
    :block="block"
    :loading="connectingWallet"
    @click="connectWallet()"
  >
    <span
      v-if="!hideLabel"
      v-text="label ?? $t('common.connectWallet')"
      class="d-inline-block mr-2"
    />

    <SuperheroWalletIcon class="wallet-icon" />
  </v-btn>
</template>

<script lang="ts" setup>
import { defineProps, PropType } from "vue";
import { storeToRefs } from "pinia";

import { useWalletConnect } from "@/composables";
import { useAccounts } from "@/stores";

import SuperheroWalletIcon from "@/assets/logos/sh-wallet.svg";

const { connectWallet, connectingWallet } = useWalletConnect();
const { activeAccount } = storeToRefs(useAccounts());

defineProps({
  label: { type: String, default: null },
  size: { type: String as PropType<"large" | undefined>, default: undefined },
  outlined: Boolean,
  hideLabel: Boolean,
  block: Boolean,
});
</script>

<style lang="scss" scoped>
.wallet-connect-btn {
  .wallet-icon {
    height: 18px;
  }
}
</style>
